import { IS_IOS_APP } from "../config/appTarget.js";

/**
 * Store listing URLs and helpers, shared by the force-update gate, the download
 * floater, and the PawMatch install modal.
 *
 * iOS is env-configurable (the numeric App Store id is assigned at submission);
 * Android is derived from the fixed package id.
 */
export const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.pawseum.app";

export const IOS_STORE_URL =
  import.meta.env.VITE_IOS_APP_STORE_URL ??
  "https://apps.apple.com/us/app/pawseum/id6773040225";

export const PLAY_STORE_AVAILABLE = true;

export type MobilePlatform = "ios" | "android";

/** Best-effort detection of the visitor's mobile OS from the user agent. */
export function detectMobilePlatform(): MobilePlatform | null {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return null;
}

/** Store URL matching the running native shell / the visitor's phone OS. */
export function storeUrlFor(platform: MobilePlatform): string {
  return platform === "ios" ? IOS_STORE_URL : ANDROID_STORE_URL;
}

/**
 * The single most relevant store URL for the current context. iOS shell / iPhone
 * visitors get the App Store. Android visitors get Google Play only once it's
 * public (`PLAY_STORE_AVAILABLE`); until then — and on desktop/unknown — we fall
 * back to the App Store, which is the store that's live for everyone.
 */
export function preferredStoreUrl(): string {
  if (IS_IOS_APP) return IOS_STORE_URL;
  const detected = detectMobilePlatform();
  if (detected === "android") {
    return PLAY_STORE_AVAILABLE ? ANDROID_STORE_URL : IOS_STORE_URL;
  }
  return IOS_STORE_URL;
}
